import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {UserGroupsComponent} from './user-groups.component';
import {LayoutModule} from '../../components/layout/layout.module';
import {SearchModule} from '../../components/search/search.module';
import {ArmTableModule} from '../../components/arm-table/arm-table.module';
import {ActionBarModule} from '../../components/action-bar/action-bar.module';
import {MaterialModule} from '../../material.module';
import { UserGroupsSummaryComponent } from './user-groups-summary/user-groups-summary.component';
import {FlexModule} from '@angular/flex-layout';
import {DividerModule} from '../../components/separator/divider.module';
import {InfoTreeModule} from '../../components/info-tree/info-tree.module';
import { UserGroupsDialogComponent } from './user-groups-dialog/user-groups-dialog.component';
import {DialogModule} from '../../components/dialog/dialog.module';
import {FormsModule} from '@angular/forms';
import {ClientFilterModule} from '../../components/client-filter/client-filter.module';
import {InnerLoaderModule} from '../../components/inner-loader/inner-loader.module';
import {InfraModule} from 'ac-infra';



@NgModule({
  declarations: [
    UserGroupsComponent,
    UserGroupsSummaryComponent,
    UserGroupsDialogComponent
  ],
    imports: [
        CommonModule,
        LayoutModule,
        SearchModule,
        ActionBarModule,
        MaterialModule,
        FlexModule,
        DividerModule,
        InfoTreeModule,
        DialogModule,
        FormsModule,
        ClientFilterModule,
        ArmTableModule,
        InnerLoaderModule,
        InfraModule
    ]
})
export class UserGroupsModule { }
